interface SimplifiedInterviewData {
  interviewContext: {
    title: string;
    description: string;
    prompt: string;
    createdBy: string;
    invitations: any[];
  };
  sessions: Array<{
    sessionUser: string;
    userRating: number | null;
    customInstructions: string;
    createdAt: string;
    responses: Array<{
      question: string;
      conversation: any; 
    }>;
  }>;
}

export const transformInterviewData = (interviewData: any): SimplifiedInterviewData => {

  const interviewContext = {
    title: interviewData.Title,
    description: interviewData.Description,
    prompt: interviewData.Prompt,
    createdBy: interviewData.CreatedBy,
    invitations: interviewData.Invitations,
  };

 
  const sessions = interviewData.Sessions
    .map((session: any) => {
      const responses = interviewData.Questions.map((question: any) => {
        const responseObj = session.Responses.find(
          (response: any) => response.InterviewQuestionId === question.Id
        );
        if (!responseObj) return null;
        let conversation: any = responseObj.ResponseText;
        try {
          const parsed = JSON.parse(responseObj.ResponseText);
          if (Array.isArray(parsed)) {
            conversation = parsed;
          }
        } catch {
          
        }
        return {
          question: question.QuestionText,
          conversation,
        };
      }).filter(Boolean);

      return {
        sessionUser: session.SessionUser,
        createdAt: session.CreatedAt,
        responses,
      };
    });


  return {
    interviewContext,
    sessions,
  };
}; 